import React, { useEffect, useState } from "react";
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { Button, Grid, IconButton, Tooltip } from "@mui/material";
import MenuItem from '@mui/material/MenuItem';
import { Apartment, ArrowBack, Description, Download, Email, Person, Phone, Replay, Reply, Send } from "@mui/icons-material";
import Header from "../layouts/Header";
import { Link, useParams } from "react-router-dom";
import { instance } from "../utils/api";
import moment from 'moment';
import { AddAssignee, Priority, Status} from "./TicketList2";
const cl = "app-page-ticket-detail"

// const Priority = (props) => {
//   const priority  = props.initialPriority;
//   const ticketId = props.ticketId;
//   console.log(priority);
// //   useEffect(() => {setPriority(props.initialPriority); setTicketId(props.ticketId)},[props.initialPriority,props.ticketId])
//   const handleChange = (event) => {
//     const newPriority = event.target.value;
//     // setPriority(newPriority);

//     const updatedData = {
//       priority: newPriority,
//     };

//     instance.put(`agents/ticket/${ticketId}`, updatedData)
//       .then((response) => {
//         if (response.status === 200) {
//           console.log("Ticket priority updated.");
//           props.updatePriority(ticketId, newPriority);
//         } else {
//           console.error("Failed to update ticket priority.");
//         }
//       });
//   };

//   return (
//     <FormControl fullWidth>
//       <Select
//         className={`proiority-select ${priority === 'high' ? '--high' : priority === 'medium' ? '--medium' : priority === 'low' ? '--low' : ""}`}
//         id="demo-simple-select"
//         value={props.initialPriority}
//         onChange={handleChange}
//         displayEmpty
//         size="small"
    
//       >
//        <MenuItem value='low'>Low</MenuItem>
//         <MenuItem value='medium'>Medium</MenuItem>
//         <MenuItem value='high'>High</MenuItem>
//         <MenuItem value='urgent'>Urgent</MenuItem>
//       </Select>
//     </FormControl>
//   )
// }

// const Status = (props) => {
//     const [status, setStatus] = useState(props.initialStatus);
//     const [ticketId, setTicketId] = useState(props.ticketId);
//     const handleChange = (event) => {
//       const newStatus = event.target.value;
//       setStatus(newStatus);
  
//       const updatedData = {
//         status: newStatus,
//       };
  
//       instance.put(`agents/ticket/${ticketId}`, updatedData)
//         .then((response) => {
//           if (response.status === 200) {
//             console.log("Ticket status updated.");
//             props.updateStatus(ticketId, newStatus);
//           } else {
//             console.error("Failed to update ticket status.");
//           }
//         });
//     };
//     return (
//       <FormControl fullWidth>
//         <Select
//           id="demo-simple-select"
//           value={status}
//           displayEmpty
//           onChange={handleChange}
//           size="small"
//           className={`proiority-select ${status === 'in progress' ? '--inprogress' : status === 'on hold' ? '--onhold' : status === 'closed' ? '--closed' : ""}`}
//         >
//           <MenuItem value={'open'}>Open</MenuItem>
//           <MenuItem value={'in progress'}>In Progress</MenuItem>
//           <MenuItem value={'on hold'}>On Hold</MenuItem>
//           <MenuItem value={'closed'}>Closed</MenuItem>
//         </Select>
//       </FormControl>
//     )
//   }

function TicketDetail() {
    const [data, setData] = useState([]);
    const [ticketAssign, setTicketAssign] = useState([])
    const [status, setStatus] = useState('');
    const [error, setError] = useState("")
    const userRole = localStorage.getItem("userRole")
    const [names, setNames] = useState([]);
    const [agentsId, setAgentsId] = useState([]);

    const [triggerRefresh, setTriggerRefresh] =React.useState(0)
    
    const handleChange = (event) => {
        setStatus(event.target.value);
    };
    const handleDownload = () => {
        const downloadLink = document.createElement('a');
        downloadLink.href = data.attachment;
        downloadLink.download = 'attachment-file-name';
        downloadLink.click();
    };

    const { ticket_id } = useParams();
    useEffect(() => {
    const fetchTicketData = async () => {
        try {
            const response = await instance.get(`tickets/${ticket_id}`);
            setData(response.data.ticket);
            setTicketAssign(response.data.assigned_to)
            console.log('asss', response.data.assigned_to)
            console.log(response.data.ticket)
        } catch (err) {
            setError(err);
            console.log(err);
        }
    };


    fetchTicketData();
}, [ticket_id, triggerRefresh]);

    const formatDateString = (dateString) => {
        const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
        return new Date(dateString).toLocaleDateString('en-US', options);
    };

    const [discussionData, setDiscussionData] = useState([])
    const [message, setMessage] = useState('');
    const postMessage = async () => {
        try {
            console.log('message:', message); // Log the message
            //   const formData = new FormData();
            //   formData.append('message', message);

            const response = await instance.post(`agents/ticket/${ticket_id}/discussion`, {
                message
            });

            setMessage('');
            await fetchDiscussionData();
        } catch (err) {
            setError(err);
            console.error('Error:', err);
            if (err.response) {
                console.error('Response Data:', err.response.data);
            }
        }
    }

    const fetchDiscussionData = async () => {
        try {
            const response = await instance.get(`agents/ticket/${ticket_id}/discussion`);
            setDiscussionData(response.data.rows);
            console.log('jkjk', response.data.rows);
        } catch (err) {
            setError(err);
            console.log(err);
        }
    };

    useEffect(() => {
        fetchDiscussionData();
    }, [ticket_id]);
    const [activityData, setActivityData] = useState([])
    const fetchActivityData = async () => {
        try {
            const response = await instance.get(`tickets/logs/${ticket_id}`);
            setActivityData(response.data.rows);
            console.log('act', response.data.rows);
        } catch (err) {
            setError(err);
            console.log(err);
        }
    };

    useEffect(() => {
        fetchActivityData();
    }, [ticket_id]);

    
    useEffect(() => {
        async function fetchAgentNames() {
          try {
            const response = await instance.get("agents/list");
            if (response.status === 200) {
    
              const agentData = response.data;
              const name = agentData.map((agent) => agent.name);
              setNames(name);
              const agentid=agentData.map((agent)=> agent.agent_id);
              setAgentsId(agentid)
              console.log({agentid})
              console.log({name })
            } else {
              console.error("Failed to fetch agent data");
            }
          } catch (error) {
            console.error("Network error:", error);
          }
        }
        fetchAgentNames();
      }, []);
      console.log(data)
    return (
        <>
            <div className="ticketlist">
                <Header />
            </div>
            <div className={cl}>
                <div className={`${cl}__title`}>
                    <Tooltip title="back">
                        {userRole === 'admin' && (
                            <Link to="/tickets">
                                <IconButton size="small">
                                    <ArrowBack />
                                </IconButton>
                            </Link>
                        )}
                        {userRole === 'agent' && (
                            <Link to="/mytickets">
                                <IconButton size="small">
                                    <ArrowBack />
                                </IconButton>
                            </Link>
                        )}
                    </Tooltip>
                    <h1>Ticket Detail</h1>
                </div>
                <div className={`${cl}__body`}>
                    <Grid container spacing={3}>
                        <Grid item md="8.5">
                            <div className={`${cl}__ticketcard`}>
                                <div className={`${cl}__ticketcard__header`}>
                                    <div className={`${cl}__ticketcard__subject`}>
                                        <h3><span>(#{data.ticket_id})</span></h3>
                                    </div>
                                    {/* <div className={`${cl}__ticketcard__actions`}>
                                        <FormControl fullWidth>
                                            <Select
                                                id="demo-simple-select"
                                                value={status}
                                                displayEmpty
                                                onChange={handleChange}
                                                size="small"
                                                className={`proiority-select ${status === 'inprogress' ? '--inprogress' : status === 'onhold' ? '--onhold' : status === 'closed' ? '--closed' : ""}`}
                                            >
                                                <MenuItem value={''}>Open</MenuItem>
                                                <MenuItem value={'inprogress'}>In Progress</MenuItem>
                                                <MenuItem value={'onhold'}>On Hold</MenuItem>
                                                <MenuItem value={'closed'}>Closed</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </div> */}
                                </div>
                                <div className={`${cl}__ticketcard__body`}>
                                    <Grid spacing={3} container>
                                        <Grid item md="12">
                                            <div className={`${cl}__ticketinfo`}>
                                                <h6>Ticket Category :<span>{data.help_topic}</span></h6>

                                            </div>
                                        </Grid>
                                        <Grid item md="6">
                                            <div className={`${cl}__ticketinfo`}>
                                                <h6>Reported By :</h6>
                                                <p>{data.full_name}</p>
                                            </div>
                                        </Grid>
                                        <Grid item md="6">
                                            <div className={`${cl}__ticketinfo`}>
                                                <h6>Assigned To:</h6>
                                                {userRole === "agent" ?
                                                <p>{ticketAssign.map(agent => agent.Agent.name).join(', ')}</p> :
                                                <div className="table-assigne">
                                                    <ul className="table-assigne__list">
                                                    {ticketAssign.length > 0 ? (
                                                        ticketAssign.map((assignedAgent, index) => (
                                                        <li key={assignedAgent.agent_id} className="table-assigne__listitem">
                                                            <Tooltip title={assignedAgent.Agent.name}>
                                                            <div className="table-assigne-box">
                                                            {assignedAgent.Agent.image ? ( 
                                                                <img className="table-assigne-pic" src={assignedAgent.Agent.image} />
                                                            ) : (
                                                                <img className="table-assigne-pic" src="/images/icons/user.svg" /> 
                                                            )}

                                                            {/* {index === data.assigned_agents.rows.length - 1 ? (
                                                                <img src="/images/icons/remove.svg" className="table-assigne-remove" />
                                                            ) : null} */}
                                                            </div>
                                                            </Tooltip>
                                                        </li>
                                                        ))
                                                    ) : null} 
                                                    <li className="table-assigne__listitem">
                                                        <AddAssignee ticketId={data.ticket_id} agentsId={agentsId} names={names} 
                                                        selectedAssignees={ticketAssign.map(agent => agent.agent_id)} 
                                                        setTriggerRefresh={setTriggerRefresh}
                                                        />
                                                    </li>
                                                    </ul>
                                                </div>
                                                }
                                            </div>
                                        </Grid>


                                        <Grid item md="6">
                                            <div className={`${cl}__ticketinfo`}>
                                                <h6>Created On :</h6>
                                                <p>{formatDateString(data.createdAt)}</p>
                                            </div>
                                        </Grid>
                                        <Grid item md="6">
                                            <div className={`${cl}__ticketinfo`}>
                                                <h6>Due Date :</h6>
                                                {data.due_date ? (
                                                    <p>{formatDateString(data.due_date)}</p>
                                                ) : (
                                                    <p>Not set</p>
                                                )}
                                            </div>
                                        </Grid>

                                        <Grid item md="6">
                                            <div className={`${cl}__ticketinfo`}>
                                                <h6>Priority :</h6>
                                                {/* <span className={`proiority-select ${data.priority === 'high' ? '--high' : data.priority === 'medium' ? '--medium' : data.priority === 'low' ? '--low' : ""}`}>{data.priority}</span> */}
                                                {data?.priority && <Priority
                                                    ticketId={data.ticket_id}
                                                    initialPriority={data.priority}
                                                    updatePriority={(ticketId, newPriority) => {
              
                                                    }}
                                                />}
                                            </div>
                                        </Grid>

                                        <Grid item md="6">
                                            <div className={`${cl}__ticketinfo`}>
                                                <h6>Status :</h6>
                                                {/* <span className={`proiority-select ${data.status === 'inprogress' ? '--inprogress' : data.status === 'onhold' ? '--onhold' : data.status === 'closed' ? '--closed' : ""}`}>{data.status}</span> */}
                                                {data?.status && <Status
                                                    ticketId={data.ticket_id}
                                                    initialStatus={data.status} 
                                                    updateStatus={(ticketId, newStatus) => {
                                                    
                                                    }}
                                                />}
                                            </div>
                                        </Grid>
                                        <Grid item md="12">
                                            <div className={`${cl}__ticketinfo`}>
                                                <h6>Overview :</h6>
                                                <p>{data.description}</p>
                                            </div>
                                        </Grid>
                                        <Grid item md="12">
                                            <div className={`${cl}__ticketinfo`}>
                                                <h6>Attachments :</h6>
                                                <ul className="attachment-list">
                                                    {data.attachment ? (
                                                        <li className="attachment-list-item">
                                                            <Description className="attachment-list-item--image" />
                                                            <span className="attachment-list-item--title">Attachment</span>
                                                            <IconButton size="small" onClick={handleDownload}>
                                                                <Download />
                                                            </IconButton>
                                                        </li>
                                                    ) : (
                                                        <li>No attachment</li>
                                                    )}
                                                </ul>

                                            </div>
                                        </Grid>
                                    </Grid>
                                </div>
                            </div>
                            <div className={`${cl}__discussion`}>
                                <h3 className={`${cl}__discussion--title`}> Discussion({discussionData ? discussionData.length : 0})
                                </h3>
                                <ul className={`${cl}__discussion__list`}>
                                    {discussionData && Array.isArray(discussionData) && discussionData.map((discussionItem) => {

                                        return (
                                            <li key={discussionItem.discussion_id} className={`${cl}__discussion__listitem`}>
                                                <div className="discussion-profile">
                                                    {discussionItem.Agent && (
                                                        <>
                                                            <img className="discussion-profile--pic" src={discussionItem.Agent.image} />
                                                            <div className="discussion-profile--info">
                                                                <div className="discussion-profile--header">
                                                                    <h6>{discussionItem.Agent.name}</h6>
                                                                    <span>{moment(discussionItem.createdAt).fromNow()}</span>
                                                                </div>
                                                                {discussionItem.message && (
                                                                    <p>{discussionItem.message}</p>
                                                                )}
                                                            </div>
                                                        </>
                                                    )}
                                                </div>
                                            </li>
                                        );
                                    })}




                                </ul>
                                <div className="discussion-comment">
                                    <textarea
                                        rows={3}
                                        placeholder="Your comment"
                                        value={message}
                                        onChange={(e) => setMessage(e.target.value)}
                                    />

                                    <Button size="small" variant="contained" type="primary" onClick={postMessage}><Send /> Submit</Button>
                                </div>
                            </div>
                        </Grid>
                        <Grid item md="3.5">
                           
                            <div className={`${cl}__activity`}>
                                <h3 className={`${cl}__activity--title`}> Activity
                                </h3>
                                <ul className={`${cl}__activity__list`}>
  {activityData && Array.isArray(activityData) && activityData.map((activityItem) => {
    return (
      <li key={activityItem.ticket_log_id} className={`${cl}__activity__listitem`}>
        <div className="discussion-profile">
          <div className="discussion-profile--info">
            <div className="discussion-profile--header">
              <h6>{activityItem.Edit_by && activityItem.Edit_by.name}</h6>
              <span>{moment(activityItem.createdAt).fromNow()}</span>
            </div>
            {activityItem.message && (
              <p>{activityItem.message} {activityItem.assigned_to && activityItem.assigned_to.name}</p>
            )}
          </div>
        </div>
      </li>
    );
  })}
</ul>

                            </div>
                            <div className={`${cl}__customerdetailscard`}>
                                <h3 className={`${cl}__customerdetailscard--title`}>User Details</h3>
                                <ul className={`${cl}__customerdetailscard--list`}>
                                    <li className={`${cl}__customerdetailscard--listitem`}>
                                        <Person />
                                        <div>
                                            <h6>Name</h6>
                                            <p>{data.full_name}</p>
                                        </div>
                                    </li>
                                    <li className={`${cl}__customerdetailscard--listitem`}>
                                        <Apartment />
                                        <div>
                                            <h6>Company</h6>
                                            <p>{data.company}</p>
                                        </div>
                                    </li>
                                    <li className={`${cl}__customerdetailscard--listitem`}>
                                        <Email />
                                        <div>
                                            <h6>Email</h6>
                                            <p>{data.email}</p>
                                        </div>
                                    </li>
                                    <li className={`${cl}__customerdetailscard--listitem`}>
                                        <Phone />
                                        <div>
                                            <h6>Phone</h6>
                                            <p>{data.phone}</p>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </Grid>
                    </Grid>
                </div>
            </div>
        </>
    )
}
export default TicketDetail;
